import React, { useEffect, useState } from "react";
import { Table, Button, Space, Select, message } from "antd";
import { EditOutlined, TrophyOutlined } from "@ant-design/icons";
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllHealthIssues } from "../../store/healthIssueSlice.js";
import StudentHealthIssueform from "../../components/forms/StudentHealthIssueForm.js";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck.js";
import { API_BASE_URL } from "../../config.js";
import AccessDenied from '../../hooks/AccessDenied'; // Adjust the import path

const { Option } = Select;

const StudentHealthIssue = () => {
  const dispatch = useDispatch();
  const userInfoString = JSON.parse(localStorage.getItem("userInfo"));
  const storedToken = userInfoString?.token;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingHealthIssue, setEditingHealthIssue] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const healthIssue = useSelector((state) => state.healthIssue);
  const { healthIssueList, loading } = healthIssue;

  const userData = userInfoString ? userInfoString : null;
  if (!userData) {
    throw new Error("No user data or token found");
  }
  const isStudent = userData?.roles?.includes("Student") ? true : false;

  useTokenExpiryCheck();

  //console.log("userData", userData);
  useEffect(() => {
    dispatch(fetchAllHealthIssues()); // Fetch all health issues for the logged-in student's IDs
  }, [dispatch]);

  const columns = [
    {
      title: "Student Id",
      dataIndex: "studentIdno",
      key: "studentIdno",
    },
   {
      title: "Student Name",
      dataIndex: "studentName",
      key: "studentName",
    },
    {
      title: "Issue Name",
      dataIndex: "issueName",
      key: "issueName",
    },
    {
      title: "Issue Type",
      dataIndex: "issueType",
      key: "issueType",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditHealthIssue(record)}
          >
            Edit
          </Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleDeleteHealthIssue(record)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const handleEditHealthIssue = (record) => {
    setEditingHealthIssue(record);
    setIsModalOpen(true);
  };
  const handleModalCancel = () => {
    setIsModalOpen(false);
    setEditingHealthIssue(null); // Clear editing state on cancel
  };
  const handleDeleteHealthIssue = async (values) => {
    try {
      const issueID = values.issueID;
      const response = await fetch(
        `${API_BASE_URL}/api/HealthIssue/PermanentDelete/${issueID}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete health issue");
      }

      dispatch(fetchAllHealthIssues());
      message.success("Health issue deleted successfully!");
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Something went wrong");
    }
  };

  const onSave = (cb) => {
    setSuccess(true);
    setIsModalOpen(false);
    dispatch(fetchAllHealthIssues());
    if (cb) cb();
  };

  const onSaveFail = (message, cb) => {
    setError(message);
    if (cb) cb();
  };
    // if (!isStudent) {
    //   return <AccessDenied />;
    // }  
  return (
    <div className="flex">
      <div style={{ display: "flex", width: "80%" }}>
        <div style={{ flex: 1, padding: "16px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 className="text-2xl font-bold">
              <TrophyOutlined style={{ marginRight: 8 }} />
              Health Issues
            </h2>
            <Button
              type="primary"
              onClick={() => {
                setIsModalOpen(true);
                setEditingHealthIssue(null); // Prepare for adding new health info
              }}
            >
              Register
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={healthIssueList}
            loading={healthIssueList.loading}
          />
        </div>
      </div>
      {isModalOpen && (
        <StudentHealthIssueform
          onSave={onSave}
          onSaveFail={onSaveFail}
          open={isModalOpen}
          onCancel={handleModalCancel}
          initialValues={editingHealthIssue}
          mode={editingHealthIssue ? "edit" : "create"}
        />
      )}
      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert
          onClose={() => setSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Changes saved successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
      >
        <Alert
          onClose={() => setError(null)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default StudentHealthIssue;
